import React from "react"

// import ChristmasLights from "./ChristmasLights"
import MinimalTouchCta from "./ChristmasTouchBanner"
import RotatingTrilingualHeadline from "./RotatingTrilingualHeadline"
import { useSyncedLangTicker } from "./useSyncedLangTicker"
import classes from "./index.module.scss"

const PotatoTImeWinter = (props) => {
  const {
    onTouchStartOrdering
  } = props

  const { index, intervalMs, onPause, onResume } =
    useSyncedLangTicker({ intervalMs: 2800, pauseOnTouch: true })
    
  return (
    <div className={classes["app-container"]}>
      {/* <ChristmasLights /> */}

      <div className={classes["snow-pro"]} />
      <div className={classes["snow-near"]} />

      {/* SAFE AREA */}
      <div
        onPointerDown={onPause}
        onPointerUp={onResume}
        onPointerCancel={onResume}
        onPointerLeave={onResume}
        className={classes["safe-area"]}
      >
        <div className={classes["content-wrapper"]}>
          <RotatingTrilingualHeadline
            index={index}
            transitionMs={500}
          />

          <div className={classes["image-section"]}>
            <div className={classes["image-container"]}>
              <div className={classes["glow-bg"]} />
              <img
                src="/assets/images/packfood-winter.svg"
                alt="Food Pack"
              />
            </div>
          </div>

          <MinimalTouchCta
            index={index}
            intervalMs={intervalMs}
            onTouch={onTouchStartOrdering}
          />
        </div>
      </div>
    </div>
  )
}

export default PotatoTImeWinter
